export default function getMapProjection(map) {
  const overlay = new google.maps.OverlayView()
  overlay.draw = _ => undefined
  overlay.setMap(map)
  return overlay.getProjection()
}



// WEBPACK FOOTER //
// ./src/helpers/map/getMapProjection.js